import { Channel as GqlChannel } from '@/types/schema.generated'

const enum LegacyChannelID {
  Okaneko = 1,
  Rakuten = 2,
  Yahoo = 3,
  Sbi = 4,
  Minkabu = 5,
  Ponta = 6,
  Okb = 7,
  Kiraboshi = 8,
  FourHundredF = 9,
  MetLife = 10,
  Hanasaku = 11,
  HokenNoMadoguchi = 12,
  Smcc = 13,
  Famipay = 14,
  RakutenInHouseAdvisor = 15,
  ZaikeiJutakuKinyu = 16,
  VitalitySmart = 17,
  RakutenUnyouSoudan = 18,
  FourHundredFInsuranceComparison = 19,
  MoneyForward = 20,
  SbiUnyouSoudan = 21,
  ChugokuGinko = 22,
  SbiMoneyPlaza = 23,
  ToyotaCorolla = 24,
  OkanekoTenshoku = 25,
  Ninpath = 26,
  OrixBank = 27,
  LifePlaza = 28,
}

const legacyChannelTypeMap = {
  [LegacyChannelID.Okaneko]: GqlChannel.Okaneko,
  [LegacyChannelID.Rakuten]: GqlChannel.Rakuten,
  [LegacyChannelID.Yahoo]: GqlChannel.Yahoo,
  [LegacyChannelID.Sbi]: GqlChannel.Sbi,
  [LegacyChannelID.Minkabu]: GqlChannel.Minkabu,
  [LegacyChannelID.Ponta]: GqlChannel.Ponta,
  [LegacyChannelID.Okb]: GqlChannel.Okb,
  [LegacyChannelID.Kiraboshi]: GqlChannel.Kiraboshi,
  [LegacyChannelID.FourHundredF]: GqlChannel.FourHundredF,
  [LegacyChannelID.MetLife]: GqlChannel.MetLife,
  [LegacyChannelID.Hanasaku]: GqlChannel.Hanasaku,
  [LegacyChannelID.HokenNoMadoguchi]: GqlChannel.HokenNoMadoguchi,
  [LegacyChannelID.Smcc]: GqlChannel.Smcc,
  [LegacyChannelID.Famipay]: GqlChannel.Famipay,
  [LegacyChannelID.RakutenInHouseAdvisor]: GqlChannel.RakutenInHouseAdvisor,
  [LegacyChannelID.ZaikeiJutakuKinyu]: GqlChannel.ZaikeiJutakuKinyu,
  [LegacyChannelID.VitalitySmart]: GqlChannel.VitalitySmart,
  [LegacyChannelID.RakutenUnyouSoudan]: GqlChannel.RakutenUnyouSoudan,
  [LegacyChannelID.FourHundredFInsuranceComparison]:
    GqlChannel.FourHundredFInsuranceComparison,
  [LegacyChannelID.MoneyForward]: GqlChannel.MoneyForward,
  [LegacyChannelID.SbiUnyouSoudan]: GqlChannel.SbiUnyouSoudan,
  [LegacyChannelID.ChugokuGinko]: GqlChannel.ChugokuGinko,
  [LegacyChannelID.SbiMoneyPlaza]: GqlChannel.Sbi,
  [LegacyChannelID.ToyotaCorolla]: GqlChannel.ToyotaCorolla,
  [LegacyChannelID.OkanekoTenshoku]: GqlChannel.Okaneko,
  [LegacyChannelID.Ninpath]: GqlChannel.Ninpath,
  [LegacyChannelID.OrixBank]: GqlChannel.OrixBank,
  [LegacyChannelID.LifePlaza]: GqlChannel.LifePlaza,
} as const satisfies Record<LegacyChannelID, GqlChannel>

export const convertLegacyChannelToGqlType = (
  chan: LegacyChannelID
): GqlChannel => legacyChannelTypeMap[chan] ?? GqlChannel.Okaneko
